// Desc: This component is responsible for rendering the main content of the application.
// Update: 30/07/2025

// React Components
import React from 'react';

// Material UI Components
import { Box, useMediaQuery } from '@mui/material';

// Components and functions from the project
import PapperBlock from './PapperBlock';

// Render Your Component
function MainContent({ children }) {
  const isMobileScreen = useMediaQuery('(max-width:600px)');

  return (
  <Box
  component="main"
  sx={(theme) => {
    const isMobile = {
      marginLeft: '0px',
      minWidth: '100vw',
      paddingTop: '85px',
      maxWidth: '100vw',
    };

    return {
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#ccc #F7F7FC',
      backgroundColor: '#F7F7FC',
      transition: 'width 0.3s ease',
      width: '100%',
      minHeight: '100vh',       // ocupa toda a altura da tela
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      ...(isMobileScreen && isMobile),
    };
  }}
>
  <PapperBlock>
    {children}
  </PapperBlock>
</Box>

  );
}

export default MainContent;
